





































































































































































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { MswAppTitle } from '@/shared/msw-app-title';
import { PageTitleConfig } from '@/shared/msw-app-title/type';
import { RootStoreState } from '@/store';
import { State } from 'vuex-class';

const cssPrefix = 'privacy';

@Component({
  components: {
    MswAppTitle,
  },
})
export default class Privacy extends SwExtendedVue {
  @State((state: RootStoreState) => state.CoreStoreModule.loggedIn)
  loggedIn: boolean;

  cssPrefix = cssPrefix;

  // For title of the page
  get getHeaderConfig(): PageTitleConfig {
    return {
      pageTitle: this.$t('privacy.title')
      .toString(),
      pageParentName: '',
      isFetchFromProps: true,
      isShowDashboardIcon: this.loggedIn ? true : false,
      isShowSlash: this.loggedIn ? true : false,
      isShowParent: this.loggedIn ? true : false,
    };
  }
}
